import { updategigUnitInfo } from "@/service/unit";
export default {
  name: "UpdateUnitAddress",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      formObj: {
        address1: ""
      },
      ruleCustom: {
        address1: [{
          pattern: /^.{0,150}$/,
          message: $t("21e8v6c", "仅150个字符以内的命名")
        }]
      }
    };
  },
  watch: {
    visible(val) {
      val && this.init();
      this.modal.visible = val;
    }
  },
  methods: {
    /* 不显示弹窗 */
    clean() {
      this.$emit("close");
      this.$refs["formCustom"].resetFields();
      this.formObj.address1 = "";
    },
    init() {
      this.formObj.address1 = this.item.address1;
    },
    /* 提交事件 */
    async onCommit() {
      this.modal.loading = true;
      const params = {
        address1: this.formObj.address1,
        unitId: this.item.unitId
      };
      let {
        data: {
          result
        }
      } = await updategigUnitInfo(params);
      if (result === 0) {
        this.$Message.success($t("d1spvi4", "操作成功"));
        this.$emit("update");
        this.clean();
      }
      this.modal.loading = false;
    }
  }
};